module.exports = __webpack_public_path__ + "img/download.0197e0e1.svg";